export const MMCC_HELLO = 'mmcc_hello'
export const MMCC_CHAT_MESSAGE = 'mmcc_chat_message'
export const MMCC_TRACE_STARTED = 'mmcc_trace_started'
export const MMCC_TRACE_ENDED = 'mmcc_trace_ended'
export const MMCC_RTC_SIGNAL = 'mmcc_rtc_signal'

export const RTC_OPEN = 'rtc_open'
export const RTC_CLOSE = 'rtc_close'
export const RTC_MESSAGE = 'rtc_message'

export const ORIENTATION = 'orientation'
